module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_14.04bd0166.jpg";